import { createAction, props } from '@ngrx/store';

import { LanguageModel } from '../models/language.model';

export const loadLanguages = createAction('[Translate] Load Languages', props<{ hotelUid: string }>());

export const setLanguages = createAction('[Translate] Set Languages', props<{ languages: LanguageModel[] }>());

export const setActualLanguage = createAction(
  '[Translate] Set Actual Language',
  props<{ actualLanguage: LanguageModel }>(),
);

export const changeLanguage = createAction('[Translate] Change Language', props<{ language: LanguageModel }>());
